/**
 * Full-bleed background video for hero sections.
 * Matches the marketing landing treatment: dark overlay, dot pattern, seamless fade.
 * Renders nothing when no videoUrl is provided.
 */
export function HeroVideo({ url }: { url?: string }) {
  if (!url) return null;
  return (
    <>
      {/* Video — scaled slightly to hide edge artifacts */}
      <div className="absolute -inset-1 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover scale-[1.02]"
          src={url}
        />
      </div>
      {/* Dot pattern texture */}
      <div
        className="absolute -inset-1 z-[1] pointer-events-none"
        aria-hidden
        style={{
          backgroundImage:
            'radial-gradient(circle, rgba(255,255,255,0.25) 1.2px, transparent 1.2px), radial-gradient(circle, rgba(255,255,255,0.25) 1.2px, transparent 1.2px)',
          backgroundSize: '20px 20px',
          backgroundPosition: '0 0, 10px 10px',
        }}
      />
      {/* Dark tint + fade to page bg */}
      <div
        className="absolute -inset-1 z-[1]"
        style={{
          background: 'linear-gradient(to bottom, rgba(46,29,16,0.55) 0%, rgba(46,29,16,0.4) 35%, rgba(46,29,16,0.25) 60%, rgba(251,247,242,0.85) 82%, var(--c-bg, #fbf7f2) 95%)',
        }}
      />
    </>
  );
}
